import React from 'react';

interface UpdateAvailableBannerProps {
  isUpdateAvailable: boolean;
  onRefresh: () => void;
}

const UpdateAvailableBanner: React.FC<UpdateAvailableBannerProps> = ({
  isUpdateAvailable,
  onRefresh,
}) => {
  if (!isUpdateAvailable) return null;

  return (
    <div className="su-update-banner">
      <div className="su-update-banner-inner">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          className="su-update-banner-icon"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        <span className="su-update-banner-text">A new version is available.</span>
        <button
          className="su-update-banner-btn"
          onClick={onRefresh}
          type="button"
        >
          REFRESH TO UPDATE
        </button>
      </div>
    </div>
  );
};

export default UpdateAvailableBanner;
